import { IconProps } from './IconProps';
export function PhoneFrameiPhoneBody(props: IconProps) {
    return (
        <svg
            width="335"
            height="100%"
            {...props}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <line
                x1="4.4036"
                x2="4.4036"
                y1="0"
                y2="100%"
                stroke="#B3B3B3"
                strokeWidth="2.08837"
            ></line>
            <line
                x1="10.4036"
                x2="10.4036"
                y1="0"
                y2="100%"
                stroke="#B3B3B3"
                strokeWidth="2.08837"
            ></line>
            <line
                x1="50%"
                x2="50%"
                y1="0"
                y2="100%"
                stroke="#f5f5f5"
                strokeWidth="297"
            ></line>
            <line
                x1="326.2056"
                x2="326.2056"
                y1="0"
                y2="100%"
                stroke="#B3B3B3"
                strokeWidth="2.08837"
            ></line>
            <line
                x1="331.1"
                x2="331.1"
                y1="0"
                y2="100%"
                stroke="#B3B3B3"
                strokeWidth="2.08837"
            ></line>
        </svg>
    );
}
